/**
 * promo-slider.js starts
 * Created by mac on 21.08.2018.
 */
function sliderCounter(slider, current, $target) {
	var curr = 1;
	if (current !== undefined) curr = current++;
	var total = slider.$slides.length,
		result = current + '/' + total;
	if ($target !== undefined) $target.text(result);
	return result;
}
$(function () {
	var $ps = $('.promoslider');
	$ps.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: slickButtons.prev,
		nextArrow: slickButtons.next,
		autoplay: true,
		autoplaySpeed: 3000,
		appendArrows: $('.promoslider-controls')
	});
});
/* promo-slider.js ends */
